import _ from 'lodash';

export const trimAndAddAsterisk = (searchStr) => {
  const search = _.isArray(searchStr) ? searchStr.join(' ') : searchStr || '';
  return `*${search.trim()}*`;
};

export const trim = (Str) => {
  const finalStr = _.isArray(Str) ? Str.join(',') : Str || '';
  return `${finalStr.trim()}`;
};
